import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const DELETE_WORKSPACE_PREBID_MODULE: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation deleteWorkspacePrebidModule($input: DeleteWorkspacePrebidModuleInput!) {
    deleteWorkspacePrebidModule(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
